import { withProps, StyledElement } from '@udecode/plate';

import { CSSProp } from 'styled-components';
import styles from 'src/shared/styles/richText';

const H4 = withProps(StyledElement, {
  as: 'h4',
  styles: {
    root: styles.h4 as CSSProp,
  },
});

export default H4;
